import { motion } from "framer-motion";
import { BRAND, waLink, DEFAULT_QUOTE_MESSAGE } from "../../lib/site";
import { WhatsAppIcon, Logo } from "./bits";

const navLinks = [
    { href: "#servicos", label: "Serviços" },
    { href: "#cotacao", label: "Cotação" },
];

export const Header = () => (
    <header
        data-testid="header-navigation"
        className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-ink/70 backdrop-blur-xl"
    >
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
            <a
                href="#topo"
                data-testid="brand-logo-link"
                className="flex items-center gap-3"
                aria-label="Borges Cargas — início"
            >
                <Logo />
                <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-mute md:block">
                    Transportadora
                </span>
            </a>

            <nav className="hidden items-center gap-8 md:flex">
                {navLinks.map((link) => (
                    <a
                        key={link.href}
                        href={link.href}
                        className="font-mono text-xs uppercase tracking-[0.2em] text-mist/70 transition-colors duration-300 hover:text-tangerine"
                    >
                        {link.label}
                    </a>
                ))}
            </nav>

            <a
                href={waLink(DEFAULT_QUOTE_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-whatsapp-quote-button"
                className="skew-cta inline-flex h-11 items-center gap-2 bg-magenta px-5 transition-colors duration-300 hover:bg-magenta-deep"
            >
                <span className="unskew flex items-center gap-2 text-sm font-semibold text-white">
                    <WhatsAppIcon className="h-4 w-4" />
                    <span className="hidden sm:inline">Pedir cotação</span>
                    <span className="sm:hidden">Cotação</span>
                </span>
            </a>
        </div>
    </header>
);
